import https from '../../utils/request.js';

//1.老师列表
export const getTeacherList = (params) => {
    return https.post('/v1/message/manager/list', params,{'Content-Type':'application/json;charset=UTF-8'})
}

//2.消息列表
export const getMessageList = (params) => {
    return https.post('/v1/message/list', params,{'Content-Type':'application/json;charset=UTF-8'})
}

//3.发送消息
export const getMessageAdd = (params) => {
    return https.post('/v1/message/add', params,{'Content-Type':'application/json;charset=UTF-8'})
}

//4.系统公告
export const getNoticeList = (params) => {
    return https.post('/v1/notice/page', params,{'Content-Type':'application/json;charset=UTF-8'})
}